﻿import * as React from 'react';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { Api } from 'pages/students/pages/merge/Api';
import { Modal, Spinner } from 'react-bootstrap';
import { Student, Success } from 'types';
import { useSuperState } from 'hooks';

import 'pages/students/pages/merge/styles/index.scss';

interface Props {
    keepAccount: Student;
    mergeAccount: Student;
    setShow: Function;
    show: boolean;
}

const ConfirmationModal = (props: Props) => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: false,
        mergeComplete: false,
        mergeMessage: ''
    });

    const MergeAccounts = async () => {

        if (props.keepAccount.Id === props.mergeAccount.Id) {

            alert(formatMessage({ id: 'cannot_merge_the_same_accounts_please_se.a44695dc', defaultMessage: 'Cannot merge the same accounts. Please select two different accounts to merge.' }));

        } else {

            setState({ loading: true });

            try {

                const res: Success<any>[] = await Api.MergeAccounts(props.keepAccount.Id, props.mergeAccount.Id);
                setState({ mergeComplete: true, mergeMessage: res[0].Message });

            } catch (e) {

                alert(e);

            } finally {

                setState({ loading: false });

            }

        }

    };

    const handleClose = () => {

        setState({ loading: false });
        props.setShow(false);

    };

    return (
        <>
            <Modal backdrop="static" onHide={handleClose} show={props.show} size="lg">
                <Modal.Body>
                    {
                        state.loading ? (
                            <Spinner animation="border" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} variant="primary" >
                                <span className="visually-hidden">

                                    <FormattedMessage defaultMessage="Loading..." id="loading.2350c7f9" />
                                </span>
                            </Spinner>
                        ) : !state.mergeComplete ? (
                            <>
                                <p>
                                    <FormattedMessage defaultMessage={'This process will permanently merge the following records for the account {mergeUsername} into the account {keepUsername}'} id="this_process_will_permanently_merge_the.a2693fcf" values={{ keepUsername: props.keepAccount.UserName, mergeUsername: props.mergeAccount.UserName }} />
                                    :
                                </p>

                                <ul>
                                    <li>
                                        <FormattedMessage defaultMessage="Content access, including exams, courses, and books" id="content_access_including_exams_courses_a.ca145908" />
                                    </li>
                                    <li>
                                        <FormattedMessage defaultMessage="Past test results" id="past_test_results.4e824247" />
                                    </li>
                                    <li>
                                        <FormattedMessage defaultMessage="Course progress" id="course_progress.887e4110" />
                                    </li>
                                    <li>
                                        <FormattedMessage defaultMessage="Student group associations and attendance" id="student_group_associations_and_attendanc.0dd8e158" />
                                    </li>
                                    <li>
                                        <FormattedMessage defaultMessage="Single Sign-On account associations (except in cases where the Account to Keep is already associated with another Single Sign-On account of the same type)" id="single_sign_on_account_associations_exce.fe3171cf" />
                                    </li>
                                </ul>

                                <p>
                                    <FormattedMessage defaultMessage="Any other personal information associated with the Account to Merge will be deleted from the system. This process is permanent and is not reversible." id="any_other_personal_information_associate.362cfe4d" />
                                </p>

                                <p>
                                    <FormattedMessage defaultMessage="Are you sure you want to continue?" id="are_you_sure_you_want_to_continue.10214389" />
                                </p>
                            </>
                        ) : (
                            <>
                                <p>
                                    { state.mergeMessage && state.mergeMessage }
                                </p>
                            </>
                        )

                    }

                </Modal.Body>
                {
                    !state.loading && (
                    <Modal.Footer>
                        <GMetrixButton
                            onClick={() => {

                                state.mergeComplete ? window.location.reload() : handleClose();

                            }} variant="secondary"
                        >
                            <FormattedMessage defaultMessage="Close" id="close.99e01fb5" />
                        </GMetrixButton>

                        {
                            !state.mergeComplete && (
                            <GMetrixButton onClick={MergeAccounts} variant="primary">
                                <FormattedMessage defaultMessage="Merge" id="merge.664c1269" />
                            </GMetrixButton>
                            )
                        }
                    </Modal.Footer>
                    )
                }
            </Modal>

        </>
    );

};

export { ConfirmationModal };